import { CfOrderGetOneDataEntity } from '../../../../api/cf/api-cf-order-get-one/api-cf-order-get-one';
import { CloudFolderFileInfo } from '../../../../api/front/cloud-folder/api-get-cloud-folder-order-file';
import './image-list.olc.scss';
import { OlcImage } from './olc-image';
import '../../../ui/loading/loading-popup.scss';
import { SelectCondition } from '../../order-preparation/order-preparation';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

type Props = {
  imgData: CloudFolderFileInfo[],
  kijshopCd: string,
  orderData: CfOrderGetOneDataEntity | null,
}
const createFolderId = (info: CloudFolderFileInfo) => {
  const { folderId } = info;
  // クラウドフォルダは最大3階層。先頭3階層まで見てフォルダ単位で束ねる。
  // 2階層固定だと、共通親の下にネストした別サブフォルダが同一フォルダ扱いになり合流するため。
  const parts = info.relativePath.split('/');
  if (parts.length < 2) return null;
  const folderPath = parts.slice(0, 3).join('/');
  return {
    id: `${folderId}/${folderPath}`,
    name: parts.slice(0, 3).pop() ?? '',
  }
}
export const OlcImageList = (props: Props) => {
  const {
    imgData,
    kijshopCd,
    orderData,
  } = props;
  const [open, setOpen] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState('');
  const tmpImages = useRef<Record<string, string>>({});
  const folderList = useMemo(() => {
    if (!imgData.length || !orderData) return [];
    const result: { name: string, id: string, folderId: string, info: CloudFolderFileInfo[] }[] = [];
    for (const info of imgData) {
      const data = createFolderId(info);
      if (data) {
        const find = result.find((v) => v.id === data.id);
        if (!find) {
          result.push({
            ...data,
            folderId: info.folderId,
            info: [info],
          });
        } else {
          find.info.push(info);
        }
      };
    }
    result.sort((a, b) => a.name > b.name ? 1 : -1 );
    const rootFolders = result.filter((v) => v.folderId === orderData.uploadFolderId);
    const childFolders = result.filter((v) => v.folderId !== orderData.uploadFolderId);
    return rootFolders.concat(childFolders);
  }, [
    imgData,
    orderData,
  ]);

  const getImage = useCallback((id: string, src: string) => {
    const data = tmpImages.current[id];
    if (data) {
      URL.revokeObjectURL(src);
    } 
    tmpImages.current[id] = src;
  }, []);
  const filterImageData = useMemo(() => {
    const find = folderList.find((v) => v.id === selectedFolder);
    const list =  find?.info ?? [];
    return [...list].sort((a, b) => a.orgFilename.localeCompare(b.orgFilename, 'ja', { numeric: true }));
  }, [
    folderList,
    selectedFolder,
  ]);

  const initSelect = useRef<boolean>(false);
  useEffect(() => {
    if (initSelect.current) return;
    if (!folderList.length) return;
    initSelect.current = true;
    setSelectedFolder(folderList[0].id);
  }, [
    folderList,
  ]);

  useEffect(() => {
    return () => {
      Object.values(tmpImages).forEach((url) => URL.revokeObjectURL(url));
    }
  }, []);
  // const debug = (arr: {name: string, id: string, folderId: string, info: CloudFolderFileInfo[]}[], repeat: number) => {
  //   const result: {name: string, id: string, folderId: string, info: CloudFolderFileInfo[]}[] = [...arr];
  //   for (let i = 0; i < repeat; i++) {
  //     result.push(...arr);
  //   }
  //   return result;
  // }
  return (
    <div className={`olc-image-cnt ${open ? 'open' : ''}`}>
      <h2 onClick={() => setOpen(!open)}>
        <div>
          <span>
            連携画像一覧
          </span>
          <span>
            &nbsp;{`(${imgData.length}枚)`}
          </span>
        </div>
        <div>
          <SelectCondition selected={open} />
        </div>
      </h2>
      <hr />
      <div className={`olc-image-wrap  ${orderData ? '' : 'loading' }`}>
        {orderData ? (
          <>
            <div className="olc-image-folder-list">
              <div  className="olc-image-folder-list__cnt">
                {/* {debug(folderList, 10).map((folder) => ( */}
                {folderList.map((folder) => (
                  <div
                    className={`
                      olc-image-folder-list__detail
                      ${selectedFolder === folder.id ? 'selected' : ''}
                    `}
                    key={folder.id}
                    title={folder.name}
                    onClick={() => setSelectedFolder(folder.id)}
                  >
                    <span>
                      {folder.name}
                    </span>
                  </div>
                ))}
              </div>  
            </div>
            <div className="olc-image-list">
              {
                orderData && filterImageData.map((img) => (
                  <OlcImage
                    key={img.id}
                    imgData={img}
                    kijshopCd={kijshopCd}
                    orderId={orderData.id}
                    initSrc={tmpImages.current[img.id]}
                    setImage={getImage}
                  />
                )
              )}
            </div>
          </>
        ) : (
          <div
          className="loading_popup__dots"
          style={{ fontSize: '0.5rem', animationDuration: `${1}s`, WebkitAnimationDuration: `${1}s` }}
          />
        )}
      </div>
    </div>
  )
}